import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { RightColumnProps } from '@components/ncFileVersions/types';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import TouchableElement from '@components/common/touchableElement';
import Separator from '@components/common/Separator';
import { isWeb } from '@helpers';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface VersionHeaderProps extends Pick<RightColumnProps, 'C' | 'selectedVersion' | 'onSendToMachine'> {}

const VersionHeader: FC<VersionHeaderProps> = ({ C, selectedVersion, onSendToMachine }) => {
  if (!selectedVersion) return null;

  return (
    <View style={{ padding: scale(12) }}>
      <Text testID={TEST_IDS.ncFileVersions.versionHeader} style={[font.Headline, { color: C('Label/Light/Primary') }]}>
        {i18n.t('Version')} {selectedVersion?.sequenceNumber}
      </Text>
      {onSendToMachine && (
        <>
          <Separator C={C} containerStyle={{ marginVertical: scale(8) }} />
          <TouchableElement testID={TEST_IDS.ncFileVersions.sendToMachineButton} onPress={onSendToMachine}>
            {() => (
              <Text style={[font.Body, { color: C('Link/Light/Primary') }, isWeb && { cursor: 'pointer' }]}>
                {`${i18n.t('Send To Machine')}...`}
              </Text>
            )}
          </TouchableElement>
        </>
      )}
    </View>
  );
};

export default VersionHeader;
